// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"df","header":"dh","overTitle":"di","image":"dj","title":"dk","description":"dl","email":"dm","button":"dn"};